import { useQuery } from '@tanstack/react-query';
import { getManufacturers, type ManufacturersResponse } from '../api';

/**
 * Hook to fetch manufacturers for complaint submission.
 * Accepts optional supplierId to filter by distributor.
 * Refetches when supplierId changes.
 */
export function useManufacturers(supplierId?: string, enabled = true) {
  return useQuery({
    queryKey: ['manufacturers', supplierId],
    queryFn: async (): Promise<ManufacturersResponse> => {
      return getManufacturers(supplierId);
    },
    enabled,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
